<a
  class="nav-link dropdown-toggle p-0"
  href="#"
  data-toggle="dropdown"
  role="button"
  aria-haspopup="true"
  aria-expanded="false"
  #menuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="menu"
  >{{ menuItem.name }}</a
>
<div class="notification-container">
  <div
    class="notfication-pending"
    *ngIf="menuItem.code == 'procedures' && pendingTrainings && currentUser"
  >
    <span>{{ pendingTrainings }}</span>
  </div>
  <div
    class="notfication"
    *ngIf="menuItem.code == 'procedures' && missingTrainings && currentUser"
  >
    <span>{{ missingTrainings }}</span>
  </div>
</div>
<mat-menu class="menu-panel" #menu="matMenu">
  <span
    *ngFor="let menuItem of menuItems; let i = index"
    class="d-flex align-items-center"
  >
    <a
      *ngIf="
        menuItem.routerLink &&
        (menuItem.visible || editing) &&
        menuItem.type == menuItemTypes.Normal
      "
      [matTooltipPosition]="'right'"
      matTooltipClass="tooltip-yellow"
      [matTooltip]="
        disabledLink(menuItem)
          ? 'You must be logged in to access this item.'
          : ''
      "
      class="dropdown-item"
      [ngClass]="{
        strikeout: !menuItem.visible && editing,
        'dropdown-edit': editing,
        'red bold': missingTrainings && menuItem.name == 'Procedure Training',
        'disabled-link': disabledLink(menuItem)
      }"
      [routerLink]="
        !disabledLink(menuItem) && !editing ? menuItem.routerLink : null
      "
      (click)="actions?.edit(menuItem)"
      >{{ menuItem.name }}
    </a>
    <a
      *ngIf="
        !menuItem.isSeparator &&
        menuItem.routerLink &&
        (menuItem.visible || editing) &&
        menuItem.type == menuItemTypes.Link
      "
      class="dropdown-item"
      [matTooltipPosition]="'right'"
      matTooltipClass="tooltip-yellow"
      [matTooltip]="
        disabledLink(menuItem)
          ? 'You must be logged in to access this item.'
          : ''
      "
      [ngClass]="{
        strikeout: !menuItem.visible && editing,
        'dropdown-edit': editing,
        'disabled-link': disabledLink(menuItem)
      }"
      target="_blank"
      href="{{ !disabledLink(menuItem) && !editing ? menuItem.route : null }}"
      (click)="actions?.edit(menuItem)"
    >
      {{ menuItem.name }}
    </a>
    <a
      *ngIf="menuItem.visible && menuItem.type == menuItemTypes.PopUp"
      class="dropdown-item"
      [matTooltipPosition]="'right'"
      matTooltipClass="tooltip-yellow"
      [matTooltip]="
        disabledLink(menuItem)
          ? 'You must be logged in to access this item.'
          : ''
      "
      [ngClass]="{
        strikeout: !menuItem.visible && editing,
        'dropdown-edit': editing,
        'disabled-link': disabledLink(menuItem)
      }"
      (click)="
        !disabledLink(menuItem) && !editing
          ? openComponent(menuItem.route ?? '')
          : actions?.edit(menuItem)
      "
      >{{ menuItem.name }}</a
    >
    <head-menu-submenu
      *ngIf="
        (menuItem.status || menuItem.visible || editing) &&
        menuItem.childMenuItems &&
        menuItem.type == menuItemTypes.Submenu
      "
      [SA]="SA"
      [menuItem]="menuItem"
      [editing]="editing"
      class="full-width"
      [ngClass]="{
        strikeout: !menuItem.visible && editing,
        'dropdown-edit': editing
      }"
    ></head-menu-submenu>
    <hr *ngIf="menuItem.type == menuItemTypes.Separator" />
    <menu-config-actions
      *ngIf="editing && !menuItem.disableEdit"
      [SA]="SA"
      [menuItem]="menuItem"
      [menuItems]="menuItems"
      [index]="i"
      [orientation]="orientationEnum.Vertical"
    ></menu-config-actions>
  </span>
</mat-menu>
